var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckpdp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 0.457031C15.9961 0.878906 15.9961 1.61719 15.5391 2.03906L6.53906 11.0391C6.11719 11.4961 5.37891 11.4961 4.95703 11.0391L0.457031 6.53906C0 6.11719 0 5.37891 0.457031 4.95703C0.878906 4.5 1.61719 4.5 2.03906 4.95703L5.76562 8.64844L13.957 0.457031C14.3789 0 15.1172 0 15.5391 0.457031Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckpdp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkpdp.0a7c2b42f9bf6bd0851529e2f5834f90.svg";